import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, Subject, tap } from 'rxjs';
import { APIRequestResources, CachedAPIRequest, LoadingService } from 'src/app/core';
import { CreateShiftRosterDTO, GetShifRostertDTO, ShiftRosterGetByDepartmentDTO, UpdateShiftRosterDTO } from '../interfaces/shift-roster.entity';
import { toSignal } from '@angular/core/rxjs-interop';
import { handleError } from 'src/app/core/utils/utils';

@Injectable({
  providedIn: 'root'
})
export class ShiftRosterService extends CachedAPIRequest {

  constructor(protected override http: HttpClient, private router: Router) {
    super(http, APIRequestResources.ShiftRosterService)
  }

  loading = inject(LoadingService);
  private refreshTrigger = new Subject<void>();
    
  $all = new BehaviorSubject<GetShifRostertDTO[]>([]);
  all = toSignal(this.$all, {initialValue: []});

  $active = new BehaviorSubject<any | undefined>(undefined);
  active = toSignal(this.$active, {initialValue: undefined});

  getAll(refresh = true) {
      return this.get<GetShifRostertDTO>({}, refresh ? 'freshness' : 'performance')
        .pipe(
          tap(res => this.$all.next([{ shift_rosters: res.data.shift_rosters }])),
          catchError(handleError)
        )
  }

  create = (shifts:any) => {
    const payload = {
      shiftRosters: shifts
    }
    return this.post<any>(payload, {}).pipe(
    );
  }

  update = (updateShiftDTO: UpdateShiftRosterDTO) => {
    return this.put<any>(updateShiftDTO, {});
  }


  getShiftRosterByDep(searchParams:any, refresh = true) {
      return this.get<ShiftRosterGetByDepartmentDTO>({endpoint: `get_by_department`, params: searchParams }, refresh ? 'freshness' : 'performance')
          .pipe();
    }

  
}
